import { rgb, PDFDocument, StandardFonts } from "pdf-lib";
import { renderChart } from "@/services/echartService";
import moment from "moment";

import { svg2png } from "svg-png-converter";

const g_pdfRadarPageNumber = 4;
const g_pdfRadarMarginTop = -180;

export async function openPdf(pdfUrl) {
  const existingPdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());
  return existingPdfBytes;
}

export async function genRadarAndDataToPdf(resultRadar) {
  if (resultRadar != undefined) {
    var chart = await renderChart(resultRadar);

    var radarSvg = await chart.getDataURL({
      type: "svg",
      pixelRatio: 2,
      backgroundColor: "#fff",
    });

    radarSvg = decodeURI(radarSvg).replace(
      "data:image/svg+xml;charset=UTF-8,",
      ""
    );

    radarSvg = await radarSvg
      .replaceAll("%3D", "=")
      .replaceAll("%2F", "/")
      .replaceAll("%23", "#")
      .replaceAll("%2C", ",")
      .replaceAll("%3A", ":")
      .replaceAll("%3B", ";");
  }
  return radarSvg;
}
export async function addRadarAndDataToPdf(
  resultRadar,
  radarSvg,
  surveyResult,
  userName,
  userPosition
) {
  if (resultRadar != undefined) {
    let radarPng = await svg2png({
      input:
        `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
` + radarSvg,
      encoding: "dataURL",
      format: "png",
      width: 800,
      height: 800,
      multiplier: 0.7,
      quality: 0.5,
    });

    console.log(radarPng);

    var pdfBuffer = await openPdf(
      "/assets/survey/itp/Définition de fonction synthétique " +
        surveyResult.resultRef +
        ".pdf"
    );

    var pdfBytes = await addImageAndDataToPdf(
      pdfBuffer,
      radarPng,
      userName,
      userPosition,
      moment(surveyResult.dateAnswering).format("DD/MM/YYYY"),
      resultRadar,
      surveyResult
    );
    return pdfBytes;
  }
  return "";
}

export async function addImageAndDataToPdf(
  existingPdfBytes,
  pngImageBytes,
  userName,
  userPosition,
  dateAnswering,
  resultRadar,
  surveyResult
) {
  const pdfDoc = await PDFDocument.load(existingPdfBytes);

  // const pngImage = await pdfDoc.embedPng(pngImageBytes);

  // const pngDims = pngImage.scale(0.5);
  const page = pdfDoc.getPages()[g_pdfRadarPageNumber];
  const timesRomanFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  /*
  page.drawImage(pngImage, {
    x: page.getWidth() / 2 - pngDims.width / 2 + 10,
    y: page.getHeight() / 2 - pngDims.height - g_pdfRadarMarginTop / 2,
    width: pngDims.width,
    height: pngDims.height,
  });*/
  let fontSize = 12;
  page.drawText(
    "(E) Extraversion <> (I) Introversion : " + surveyResult.resultDetails[1],
    {
      x: 165,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 2 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText(
    "(S) Sensation <> (N) Intuition : " + surveyResult.resultDetails[2],
    {
      x: 165,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 4 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );

  page.drawText(
    "(T) Pensée <> (F) Sentiments :  " + surveyResult.resultDetails[3],
    {
      x: 165,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 6 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText(
    "(J) Jugement <> (P) Perception : " + surveyResult.resultDetails[4],
    {
      x: 165,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 8 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );
  fontSize = 18;

  const firstPage = pdfDoc.getPages()[0];
  firstPage.drawText(userName, {
    x: 50,
    y: 4 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(1, 1, 1),
  });
  const timesRomanFontItalic = await pdfDoc.embedFont(
    StandardFonts.HelveticaOblique
  );
  firstPage.drawText(
    userPosition.charAt(0).toUpperCase() + userPosition.slice(1),
    {
      x: 50,
      y: 3 * fontSize,
      size: fontSize - 6,
      font: timesRomanFontItalic,
      color: rgb(1, 1, 1),
    }
  );
  firstPage.drawText(dateAnswering, {
    x: 50,
    y: 1.5 * fontSize,
    size: fontSize - 6,
    font: timesRomanFontItalic,
    color: rgb(1, 1, 1),
  });
  /*
  page.drawText(
    "(E) Extraversion" + " : " + Math.max(0, resultRadar[7].value),
    {
      x: 165,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 2 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText("<>", {
    x: page.getWidth() / 2,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 2 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });
  page.drawText(
    "(I) Introversion" + " : " + Math.max(0, resultRadar[3].value),
    {
      x: page.getWidth() / 2 + 35 + 10,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 2 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );

  page.drawText("(P) Perception : " + Math.max(0, resultRadar[0].value), {
    x: 165,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 8 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });
  page.drawText("<>", {
    x: page.getWidth() / 2,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 8 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });
  page.drawText("(J) Jugement : " + Math.max(0, resultRadar[4].value), {
    x: page.getWidth() / 2 + 35 + 10,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 8 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });

  page.drawText(
    resultRadar[1].label + " : " + Math.max(0, resultRadar[1].value),
    {
      x: 165,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 6 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText("<>", {
    x: page.getWidth() / 2,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 6 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });
  page.drawText("(T) Pensée : " + Math.max(0, resultRadar[5].value), {
    x: page.getWidth() / 2 + 35 + 10,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 6 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });

  page.drawText(
    resultRadar[2].label + " : " + Math.max(0, resultRadar[2].value),
    {
      x: 165,
      y: page.getHeight() / 2 - g_pdfRadarMarginTop - 4 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText("<>", {
    x: page.getWidth() / 2,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 4 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });
  page.drawText("(S) Sensation : " + Math.max(0, resultRadar[6].value), {
    x: page.getWidth() / 2 + 35 + 10,
    y: page.getHeight() / 2 - g_pdfRadarMarginTop - 4 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0, 0),
  });
  fontSize = 18;

  const firstPage = pdfDoc.getPages()[0];
  firstPage.drawText(userName, {
    x: 50,
    y: 4 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(1, 1, 1),
  });
  const timesRomanFontItalic = await pdfDoc.embedFont(
    StandardFonts.HelveticaOblique
  );
  firstPage.drawText(
    userPosition.charAt(0).toUpperCase() + userPosition.slice(1),
    {
      x: 50,
      y: 3 * fontSize,
      size: fontSize - 6,
      font: timesRomanFontItalic,
      color: rgb(1, 1, 1),
    }
  );
  firstPage.drawText(dateAnswering, {
    x: 50,
    y: 1.5 * fontSize,
    size: fontSize - 6,
    font: timesRomanFontItalic,
    color: rgb(1, 1, 1),
  });*/
  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/octet-stream" });
  return blob;
}
